import { Component, OnInit } from '@angular/core';
import { ScoringService } from '../../../services/scoring.service';
import { ActivatedRoute } from '@angular/router';
import { BankTransactionService } from '../../../services/bank_transaction.service';
import { LeadService } from '../../../services/lead.service';
import { ErrorMessageService } from '../../../../shared/error-message.service';

declare var moment: any;

declare let zingchart: any;

@Component({
    selector: 'app-lead-bank-aggregation',
    templateUrl: './lead-bank-aggregation.component.html',
    styleUrls: ['./lead-bank-aggregation.component.css'],
})
export class LeadBankAggregationComponent implements OnInit {
    lead_id: any = null;
    scoring: any = null;
    history = null;
    myConfig = null;
    months = [];
    shortDebtSummary = null;
    largeDebtSummary = null;
    unidentifiedDebtSummary = null;
    transactionLoading = false;
    showFilter: boolean;
    bankAggregationRequestParamsFilter = new Map();
    paramsFilter = new Map();
    cardTransactionParamsFilter = new Map();
    urlParams: string = '';
    bankAggregationRequestUrlParams: string = '';
    cardTransactionUrlParams: string = '';
    pageFilter = '';
    bankAggregationRequestPageFilter = '';
    cardTransactionPageFilter = '';
    score = 0;

    dateInputValStart: string = '';
    dateInputValEnd: string = '';
    cardTransactionDateInputValStart: string = '';
    cardTransactionDateInputValEnd: string = '';
    bankAggregationRequestDateInputValCreatedAt: string = '';
    bankAggregationRequestDateInputValLastStatusAt: string = '';
    bankTransaction;
    bankCardTransaction;
    bankAggregation;
    bankAggregationToken;
    bankAggregationRequests;
    bankAggregationTokenizedLoading = false;
    bankAggregationRequestStatus = [
        {
            name: 'Widget', value: 1, description: ''
        },
        {
            name: 'Login Success', value: 2, description: ''
        },
        {
            name: 'Login Failed', value: 3, description: ''
        },
        {
            name: 'Info Error Read', value: 4, description: ''
        },
        {
            name: 'Info Begin Read', value: 5, description: ''
        },
        {
            name: 'Info End Read', value: 6, description: ''
        },
        {
            name: 'Info Complete', value: 7, description: ''
        },
        {
            name: 'Tokenized', value: 8, description: ''
        },
        {
            name: 'Tokenized Failed', value: 9, description: ''
        }
    ];
    options: any = {};

    accounts: any = [];
    cards: any = [];

    constructor(
        private activate: ActivatedRoute,
        private scoringService: ScoringService,
        private bankTransactionService: BankTransactionService,
        private leadService: LeadService,
        private errorMessageService: ErrorMessageService,
    ) {
        this.options = {
            locale: { format: 'YYYY-MM-DD' },
            autoUpdateInput: false,
            singleDatePicker: true,
            alwaysShowCalendars: true,
            maxDate: moment().format('YYYY-MM-DD'),
        };
    }

    ngOnInit() {
        this.activate.params.subscribe((params) => {
            this.lead_id = params['id'];
            this.getBankAggregation();
            this.getBankAggregationToken();
            this.getBankAggregationRequests();
            this.getBankTransactions();
            this.getAccountsList();
            this.getBankCardTransactions();
            this.getCardsList();
        });
    }

    getBankAggregation(){
        this.leadService
            .getBackAggregation(this.lead_id)
            .toPromise()
            .then((answer) => {
                this.bankAggregation = answer;
            });
    }

    getBankAggregationToken(){
        this.leadService
            .getBankAggregationToken(this.lead_id)
            .toPromise()
            .then((token) => {
                this.bankAggregationToken = token;
            });
    }

    getBankAggregationRequests(page = 0) {
        this.bankAggregationRequests = null;
        this.setBankAggregationRequestPageFilter(page);
        this.bankTransactionService
            .getBankAggregationRequestPaginatedList(this.lead_id, this.bankAggregationRequestUrlParams + this.bankAggregationRequestPageFilter)
            .subscribe((list) => {
                this.bankAggregationRequests = list;
            });
    }

    getBankTransactions(page = 0) {
        this.bankTransaction = null;
        this.setPageFilter(page);
        this.bankTransactionService
            .getPaginatedList(this.lead_id, this.urlParams + this.pageFilter)
            .subscribe((list) => {
                this.bankTransaction = list;
            });
    }

    getBankCardTransactions(page = 0) {
        this.bankCardTransaction = null;
        this.setCardTransactionPageFilter(page);
        this.bankTransactionService
            .getCardTransactionPaginatedList(this.lead_id, this.cardTransactionUrlParams + this.cardTransactionPageFilter)
            .subscribe((list) => {
                this.bankCardTransaction = list;
            });
    }

    getAccountsList() {
        this.bankTransactionService
            .getAccountList(this.lead_id)
            .subscribe((list) => {
                this.accounts = list;
            });
    }

    getCardsList() {
        this.bankTransactionService
            .getCardList(this.lead_id)
            .subscribe((list) => {
                this.cards = list;
            });
    }
    getParamsFilter(event: any) {
        this.paramsFilter.set(event.target.name, event.target.value);
    }
    getBankAggregationRequestParamsFilter(event: any) {
        this.bankAggregationRequestParamsFilter.set(event.target.name, event.target.value);
    }
    makeBankAggregationRequestFilter() {
        this.bankAggregationRequestUrlParams = '';
        this.bankAggregationRequestParamsFilter.forEach(function (value, key) {
            if (value) {
                this.bankAggregationRequestUrlParams += key + '=' + value + '&';
            }
        }, this);
        this.getBankAggregationRequests();
    }
    setBankAggregationRequestPageFilter(page) {
        this.bankAggregationRequestPageFilter = '';
        if (page) {
            this.bankAggregationRequestPageFilter = 'page=' + page;
        }
    }
    clearBankAggregationRequestFilter(event) {
        if (!event.target.value) {
            if (event.target.name === 'created_at') {
                let start = {
                    target: {
                        name: event.target.name,
                        value: '',
                    },
                };

                this.bankAggregationRequestDateInputValCreatedAt = '';

                this.getBankAggregationRequestParamsFilter(start);
                this.makeBankAggregationRequestFilter();
            }

            if (event.target.name === 'last_status_at') {
                let end = {
                    target: {
                        name: event.target.name,
                        value: '',
                    },
                };

                this.bankAggregationRequestDateInputValLastStatusAt = '';

                this.getBankAggregationRequestParamsFilter(end);
                this.makeBankAggregationRequestFilter();
            }
        }
    }

    selectedBankAggregationRequestDate(value: any, input_name) {
        let start = {
            target: {
                name: input_name,
                value: value.start.format('YYYY-MM-DD'),
            },
        };
        let end = {
            target: {
                name: input_name,
                value: value.end.format('YYYY-MM-DD'),
            },
        };

        if (input_name === 'created_at') {
            this.bankAggregationRequestDateInputValCreatedAt = start.target.value;
        }

        if (input_name === 'last_status_at') {
            this.bankAggregationRequestDateInputValLastStatusAt = end.target.value;
        }

        this.getBankAggregationRequestParamsFilter(start);
        this.getBankAggregationRequestParamsFilter(end);
        this.makeBankAggregationRequestFilter();
    }

    getCardTransactionParamsFilter(event: any) {
        this.cardTransactionParamsFilter.set(event.target.name, event.target.value);
    }
    makeFilter() {
        this.urlParams = '';
        this.paramsFilter.forEach(function (value, key) {
            if (value) {
                this.urlParams += key + '=' + value + '&';
            }
        }, this);
        this.getBankTransactions();
    }
    makeCardTransactionFilter() {
        this.cardTransactionUrlParams = '';
        this.cardTransactionParamsFilter.forEach(function (value, key) {
            if (value) {
                this.cardTransactionUrlParams += key + '=' + value + '&';
            }
        }, this);
        this.getBankCardTransactions();
    }
    convertToStatusTitle(status) {
        // for (let i = 0; i < status.length; i++) {
        //     months[i] = this.monthTitle[months[i]];
        // }
        // return months;
    }
    setPageFilter(page) {
        this.pageFilter = '';
        if (page) {
            this.pageFilter = 'page=' + page;
        }
    }

    setCardTransactionPageFilter(page) {
        this.cardTransactionPageFilter = '';
        if (page) {
            this.cardTransactionPageFilter = 'page=' + page;
        }
    }

    selectedDate(value: any, input_name) {
        let start = {
            target: {
                name: input_name,
                value: value.start.format('YYYY-MM-DD'),
            },
        };
        let end = {
            target: {
                name: input_name,
                value: value.end.format('YYYY-MM-DD'),
            },
        };

        if (input_name === 'created_at_start') {
            this.dateInputValStart = start.target.value;
        }

        if (input_name === 'created_at_end') {
            this.dateInputValEnd = end.target.value;
        }

        this.getParamsFilter(start);
        this.getParamsFilter(end);
        this.makeFilter();
    }

    selectedCardTransactionDate(value: any, input_name) {
        let start = {
            target: {
                name: input_name,
                value: value.start.format('YYYY-MM-DD'),
            },
        };
        let end = {
            target: {
                name: input_name,
                value: value.end.format('YYYY-MM-DD'),
            },
        };

        if (input_name === 'start_date') {
            this.cardTransactionDateInputValStart = start.target.value;
        }

        if (input_name === 'end_date') {
            this.cardTransactionDateInputValEnd = end.target.value;
        }

        this.getCardTransactionParamsFilter(start);
        this.getCardTransactionParamsFilter(end);
        this.makeCardTransactionFilter();
    }

    clearFilter(event) {
        if (!event.target.value) {
            if (event.target.name === 'created_at_start') {
                let start = {
                    target: {
                        name: event.target.name,
                        value: '',
                    },
                };

                this.dateInputValStart = '';

                this.getParamsFilter(start);
                this.makeFilter();
            }

            if (event.target.name === 'created_at_end') {
                let end = {
                    target: {
                        name: event.target.name,
                        value: '',
                    },
                };

                this.dateInputValEnd = '';

                this.getParamsFilter(end);
                this.makeFilter();
            }
        }
    }

    clearCardTransactionFilter(event) {
        if (!event.target.value) {
            if (event.target.name === 'start_date') {
                let start = {
                    target: {
                        name: event.target.name,
                        value: '',
                    },
                };

                this.cardTransactionDateInputValStart = '';

                this.getCardTransactionParamsFilter(start);
                this.makeCardTransactionFilter();
            }

            if (event.target.name === 'end_date') {
                let end = {
                    target: {
                        name: event.target.name,
                        value: '',
                    },
                };

                this.cardTransactionDateInputValEnd = '';

                this.getCardTransactionParamsFilter(end);
                this.makeCardTransactionFilter();
            }
        }
    }

    findStatusById(id){
        if(!id){
            return {};
        }
        return this.bankAggregationRequestStatus.find(status => status.value === id);
    }

    makeBankAggregationTokenized()
    {
        this.bankAggregationTokenizedLoading = true;
        this.bankTransactionService
            .makeBankAggregationTokenized(this.lead_id)
            .subscribe((response) => {
                if(response.status){
                    this.errorMessageService.showSuccess(`The aggregation tokenized has been ordered`);
                }else{
                    this.errorMessageService.showError(response.description);
                    this.getBankAggregationToken();
                }
                this.getBankAggregationRequests();
                this.bankAggregationTokenizedLoading = false;
            });
    }

    updateBankAggregationStatus()
    {
        this.bankTransactionService
            .updateBankAggregationTokenStatus(this.lead_id)
            .subscribe((token) => {
                this.bankAggregationToken = token;
                if(token.is_active){
                    this.errorMessageService.showSuccess('The token has been updated (Active)');
                }else{
                    this.errorMessageService.showError('The token has been updated (Deactive)');
                }
            });
    }

}
